import { BaseService } from "@/services/BaseService";
import {
  RegionBootstrapResultDto,
  RegionResponseDto,
  RegionsFilters,
} from "@/types/admin-region";

class AdminRegionsService extends BaseService {
  private basePath = "/admin/regions";

  async getRegions(filters?: RegionsFilters): Promise<RegionResponseDto[]> {
    return this.get<RegionResponseDto[]>(this.basePath, {
      activeOnly: filters?.activeOnly ? "true" : undefined,
    });
  }

  async getRegion(code: string): Promise<RegionResponseDto> {
    return this.get<RegionResponseDto>(
      `${this.basePath}/${encodeURIComponent(code)}`,
    );
  }

  async bootstrapRegions(): Promise<RegionBootstrapResultDto> {
    return this.post<RegionBootstrapResultDto>(`${this.basePath}/bootstrap`);
  }
}

export const adminRegionsService = new AdminRegionsService();
